import { FormikValues } from 'formik';

export const fields = {
  BRANCH: 'branch',
  SALES_TODAY: 'sales_today',
  AVAILMENT_POWERED_BUILDS: 'availment_powered_builds',
  AVAILMENT_PROMO: 'availment_promo',
  ITEM_FIND_TODAY: 'item_find_today',
  PERIPHERALS_HARDSELL: 'peripherals_hardsell',
  EMPLOYEE_BUILDS_PERFORMANCE: 'employee_builds_performance'
};

export const initialPeripheralsHardsell = {
  sales: '',
  quantity: 0
};

export const initialEmployeeBuildsPerformance = {
  sales: '',
  entry_qty: 0,
  mid_qty: 0,
  high_qty: 0
};

export const initialValues: FormikValues = {
  [fields.BRANCH]: '',
  [fields.SALES_TODAY]: 0,
  [fields.AVAILMENT_POWERED_BUILDS]: 0,
  [fields.AVAILMENT_PROMO]: 0,
  [fields.ITEM_FIND_TODAY]: '',
  [fields.PERIPHERALS_HARDSELL]: [],
  [fields.EMPLOYEE_BUILDS_PERFORMANCE]: []
};
